/**
 * @deprecated
 * use PaymentsRoutePaths instead
 */
export enum PaymentsExternalRoute {
  ThreeDSecure = 'Payments/3DSecure',
}
